import { ATIVO_TIPO } from '@investirapri/financa.js/lib/enums';

export const AVALIACAO_MODELO_TIPO = {
  fundo: {
    id: 'fundo',
    label: 'Avaliação de Fundo'
  },
  gestor: { id: 'gestor', label: 'Avaliação de Gestor' }
};

const AVALIACAO_MODELO = {
  modelo_gestora: {
    id: 'modelo_gestora',
    label: 'Avaliação de Gestora',
    qtd_questoes: 34,
    descricao: 'Modelo focado em Avaliação de Sustentabilidade e Aspectos ESG/ASG.',
    sessoes: ['potencialidade_fiduciaria', 'conflitos_asg'],
    tipo: AVALIACAO_MODELO_TIPO.gestor.id,
    ativo_tipo_id: null
  },
  modelo_fundo_passivo: {
    id: 'modelo_fundo_passivo',
    label: 'Avaliação de Fundo Passivo',
    qtd_questoes: 33,
    descricao: 'Modelo voltado para análise de conformidade regulatória dos fundos passivos.',
    sessoes: ['potencialidade_fiduciaria', 'conflitos_asg', 'condicoes_regulamentares'],
    tipo: AVALIACAO_MODELO_TIPO.fundo.id,
    ativo_tipo_id: [ATIVO_TIPO.CTRE.id, ATIVO_TIPO.CTID.id]
  },
  modelo_fundo_investimento_participacoes: {
    id: 'modelo_fundo_investimento_participacoes',
    label: 'Avaliação de Fundo Investimento em Participações',
    qtd_questoes: 31,
    descricao:
      'Modelo voltado para análise de conformidade regulatória dos fundos investimento em participações.',
    sessoes: ['potencialidade_fiduciaria', 'conflitos_asg', 'condicoes_regulamentares'],
    tipo: AVALIACAO_MODELO_TIPO.fundo.id,
    ativo_tipo_id: [ATIVO_TIPO.CTPA.id, ATIVO_TIPO.CTPI.id]
  },
  modelo_fundo_credito_privado: {
    id: 'modelo_fundo_credito_privado',
    label: 'Avaliação de Fundo Investimento em Crédito Privado',
    qtd_questoes: 34,
    descricao:
      'Modelo voltado para análise de conformidade regulatória dos fundos investimento em crédito privado.',
    sessoes: ['potencialidade_fiduciaria', 'conflitos_asg', 'condicoes_regulamentares'],
    tipo: AVALIACAO_MODELO_TIPO.fundo.id,
    ativo_tipo_id: [ATIVO_TIPO.CTCP.id]
  },
  modelo_fundo_considerado_ativo_final: {
    id: 'modelo_fundo_considerado_ativo_final',
    label: 'Avaliação de Fundo Investimento Ativo Final',
    qtd_questoes: 31,
    descricao:
      'Modelo voltado para análise de conformidade regulatória dos fundos investimento considerado ativo final.',
    sessoes: ['potencialidade_fiduciaria', 'conflitos_asg', 'condicoes_regulamentares'],
    tipo: AVALIACAO_MODELO_TIPO.fundo.id,
    ativo_tipo_id: [
      ATIVO_TIPO.CTRF.id,
      ATIVO_TIPO.CTRFPU.id,
      ATIVO_TIPO.CTRV.id,
      ATIVO_TIPO.CTRVA.id,
      ATIVO_TIPO.CTRVBDR.id,
      ATIVO_TIPO.CTII.id
    ]
  },
  modelo_demais_fundos: {
    id: 'modelo_demais_fundos',
    label: 'Demais Fundos de Investimentos',
    qtd_questoes: 34,
    descricao:
      'Modelo voltado para análise de conformidade regulatória dos demais fundos de investimentos.',
    sessoes: ['potencialidade_fiduciaria', 'conflitos_asg', 'condicoes_regulamentares'],
    tipo: AVALIACAO_MODELO_TIPO.fundo.id,
    ativo_tipo_id: []
  }
};

export default AVALIACAO_MODELO;
